module.exports = __webpack_public_path__ + "img/17a46e5.png";